import reachability from './reachability'

const services = {
  reachability,
}

export default services
